import Vue from 'vue'
import VCalendar from 'v-calendar'
import App from './App.vue'
import router from './router'
import store from './store'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { alpha, email, min, required } from 'vee-validate/dist/rules'
import VueTheMask from 'vue-the-mask'
import { validation } from './mixins/validation'
import { general } from './mixins/general'
import './styles/base.less'
import BaseTable from "@/components/BaseTable"
import BaseAutocomplete from "@/components/BaseAutocomplete"
import { Install_Error_Reporter } from '@/error_reporter'

const moment = require('moment');
require('moment/locale/ro');

Vue.use(require('vue-moment'), {
  moment
});
Vue.use(VueTheMask)
Vue.mixin(validation)
Vue.mixin(general)
Vue.component('BaseTable', BaseTable)
Vue.component('Autocomplete', BaseAutocomplete)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});
extend('required', {
  ...required,
  message: 'This field is required!'
})
extend('email', email)
extend('alpha', alpha)
extend('min', min)
extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target
  },
  message: 'Parolele nu coincid'
})
Vue.config.productionTip = false

Install_Error_Reporter(Vue, router, store)

import Toast, { POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

Vue.use(Toast, {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  newestOnTop: true,
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
